import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';

@Component({
  selector: 'app-menu-index',
  templateUrl: './menu-index.component.html',
  styleUrls: ['./menu-index.component.scss']
})

export class MenuIndexComponent implements OnInit {

  selectedValue: string;
  roles: string[];
  userRoles: string[];
  allRoles: any;

  constructor(
    private router: Router,
    private keycloakService: KeycloakService
  ) {

  }

  ngOnInit() {
    this.userRoles = this.keycloakService.getUserRoles();
    //this.userRoles = [Role.Catalog, Role.Coverage, Role.Orders, Role.Products, Role.Resources, Role.Tasks, Role.Templates];
    this.allRoles = Role;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setIndexMenu(event.url);
      }
    });
  }

  public goToOrders(): void {
    this.router.navigate(['/provision/orders/search/']);
  }

  public goToTasks(): void {
    this.router.navigate(['/provision/tasks/search/']);
  }

  public goToProducts(): void {
    this.router.navigate(['/provision/products/search/']);
  }

  public goToCatalog(): void {
    this.router.navigate(['/provision/catalog']);
  }

  public goToManagement(): void {
    this.router.navigate(['/provision/management/']);
  }

  public goToResources(): void {
    this.router.navigate(['/provision/resourcest/']);
  }

  private setIndexMenu(url: string) {
    if (url.includes('orders') || url === '/') {
      this.selectedValue = 'orders';
    }
    if (url.includes('tasks')) {
      this.selectedValue = 'tasks';
    }
    if (url.includes('products')) {
      this.selectedValue = 'products';
    }
    if (url.includes('provision/catalog')) {
      this.selectedValue = 'catalog';
    }
    if (url.includes('management')) {
      this.selectedValue = 'management';
    }
    if (url.includes('resources')) {
      this.selectedValue = 'resources';
    }
  }
}
